import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import StructureFields from "components/_refactor/fields/structure";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import InputText from "components/_refactor/text/input";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import useStructureQueries from "hooks/useStructureQueries";
import TableDataSheetProduct from "./components/table";
import DatasheetCard from "./components/datasheet";
import PhotosCatalog from "./components/photos-catalog";
import TableLinks from "./components/table-links";

export default function FichaProduto() {
  const { getProductLines } = useStructureQueries();
  const [structureFilters, setStructureFilters] = useState({});
  const [filters, setFilters] = useState({
    productCode: "",
    description: "",
    colection: "",
    line: "",
  });
  const [page, setPage] = useState(0);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [isLoading, setIsLoading] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [openDatasheet, setOpenDatasheet] = useState(false);
  const [openPhotosCatalog, setOpenPhotosCatalog] = useState(false);
  const [lineData, setLineData] = useState([]);
  const [colectionsData, setCollectionsData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [downloadList, setDownloadList] = useState(null);
  const [openDownloadList, setOpenDownloadList] = useState(false);

  const [data, setData] = useState([]);
  const snackbar = useSnackbar();

  const handleSearch = async ({ page = 0, sizePerPage = 25 }) => {
    setIsLoading(true);
    try {
      const codigosProduto = (filters.productCode || "")
        .split(/[\s,]+/)
        .filter(Boolean)
        .join(",");

      const params = [
        `page=${page}`,
        `pageSize=${sizePerPage}`,
        `marca=${structureFilters.idMarca || ""}`,
        `filter=${filters.description || ""}`,
        `colecao=${filters.colection?.NomeColecao || ""}`,
        `linha=${filters.line?.IdProdutoLinha || ""}`,
        `codigosProduto=${codigosProduto}`,
      ];

      const response = await Api.get(
        "product-search-list",
        "product",
        "?" + params.join("&"),
        true
      );
      setData(response.Result.ListaProdutos || []);
      setPage(page);
      setTotalRegisters(response.Result.TotalRegistros || 0);
      setCurrentSizePerPage(sizePerPage);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar os produtos: " + error.message, {
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getProductsLine = async () => {
    setIsLoading(true);
    try {
      const result = await getProductLines();
      const res = result?.data ?? {};
      setLineData(res.Linha ?? []);
      setCollectionsData(res.Colecao ?? []);
    } catch (error) {
      snackbar.showMessage(
        "Erro ao buscar as linhas de produtos: " + error.message,
        {
          severity: "error",
        }
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadDataSheet = async (downloadType = "completo") => {
    setIsLoading(true);
    try {
      if (!selectedItems.length) {
        snackbar.showMessage(
          "Selecione ao menos um produto para baixar as imagens.",
          { severity: "error" }
        );
        setIsLoading(false);
        return;
      }

      let apenaFotos = false;
      let apenaFicha = false;

      if (downloadType === "apenasFotos") {
        apenaFotos = true;
      } else if (downloadType === "apenasFicha") {
        apenaFicha = true;
      }

      const downloadFilters = {
        apenaFotos,
        apenaFicha,
        idMarca: structureFilters.idMarca,
        codigosProduto: selectedItems.join(","),
        linha: filters.line?.IdProdutoLinha || "",
        colecao: filters.colection?.NomeColecao || "",
      };

      await Api.post(
        "download-catalog-product",
        "trocasDevolucoes",
        {
          fichaProduto: true,
          filtroFichaProduto: downloadFilters,
        },
        true
      );

      handleGetZipLink();
    } catch (error) {
      snackbar.showMessage("Falha ao baixar imagens!", { severity: "error" });
      setIsLoading(false);
    }
  };

  const handleGetZipLink = async () => {
    try {
      setOpenDownloadList(true);
      setIsLoading(true);
      const response = await Api.get(
        "list_download-catalog-product",
        "trocasDevolucoes",
        "?fichaProduto=true",
        true
      );
      setDownloadList(response?.Result?.ListaDownload);
    } catch (error) {
      snackbar.showMessage("Falha ao obter links de download!", {
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
  };
  const handleTableChange = ({ page, sizePerPage }) => {
    setPage(page - 1);
    setCurrentSizePerPage(sizePerPage);
    handleSearch({ page, sizePerPage });
  };

  useEffect(() => {
    getProductsLine();
  }, []);

  return (
    <>
      <HeaderClientes section="Ficha de Produto" subsection="Produtos" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={isLoading}
          searching={isLoading}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            onStructureFieldsChange={setStructureFilters}
            disableAll={isLoading}
            onStructureFieldsLoad={setStructureFilters}
            hideFields={["channel", "economicGroup", "store", "representative"]}
            clearFilters={clearFilters}
            handleSearch={handleSearch}
          />
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <InputText
              label="Código do Produto"
              value={filters.productCode}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  productCode: e.target.value,
                });
              }}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <InputText
              label="Descrição do Produto"
              value={filters.description}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  description: e.target.value,
                });
              }}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <AutoCompleteField
              label="Nome da Coleção"
              options={colectionsData}
              loading={isLoading}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  colection: e,
                });
              }}
              value={filters.colection}
              disabled={isLoading}
              optionLabelKey="NomeColecao"
              optionIdKey="NomeColecao"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <AutoCompleteField
              label="Categoria/Linha"
              options={lineData}
              loading={isLoading}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  line: e,
                });
              }}
              value={filters.line}
              disabled={isLoading}
              optionLabelKey="Descricao"
              optionIdKey="IdProdutoLinha"
            />
          </Grid>
        </FilterCard>

        <TableDataSheetProduct
          data={data}
          loading={isLoading}
          totalRegistros={totalRegisters}
          currentPage={page}
          currentSizePerPage={currentSizePerPage}
          onTableChange={handleTableChange}
          handleOpenDatasheet={(id) => {
            setOpenDatasheet(id);
          }}
          handleOpenPhotosCatalog={(id) => {
            setOpenPhotosCatalog(id);
          }}
          handleDownloadDataSheet={handleDownloadDataSheet}
          handleGetZipLink={handleGetZipLink}
          onSelectedItemsChange={setSelectedItems}
        />

        {openDatasheet && (
          <DatasheetCard
            id={openDatasheet}
            close={() => setOpenDatasheet(false)}
          />
        )}

        {openPhotosCatalog && (
          <PhotosCatalog
            id={openPhotosCatalog}
            close={() => setOpenPhotosCatalog(false)}
          />
        )}

        {openDownloadList && (
          <TableLinks
            data={downloadList}
            close={() => setOpenDownloadList(false)}
            searching={isLoading}
          />
        )}
      </Container>
    </>
  );
}
